export default {
  sender: {
    name: '',
    email: '',
    phone: '',
    address: {
      city: '',
      name: '',
      notes: '',
      state: '',
      number: '',
      country: '',
      district: '',
      complement: '',
      state_abbr: '',
      postal_code: ''
    },
    document: '',
    state_register: '',
    company_document: ''
  },
  receiver: {
    name: '',
    email: '',
    phone: '',
    address: {
      city: '',
      name: '',
      notes: '',
      state: '',
      number: '',
      country: '',
      district: '',
      complement: '',
      state_abbr: '',
      postal_code: ''
    },
    document: '',
    state_register: '',
    company_document: ''
  },
  products: [
    {
      id: '',
      name: '',
      price: '',
      volumes: [
        {
          width: '',
          height: '',
          length: '',
          weight: ''
        }
      ],
      quantity: '',
      insurance: ''
    }
  ],
  amount: {
    total: null,
    shipping: null
  },
  invoice: {
    key: '',
    serie: '',
    value: null,
    number: '',
    issued_at: ''
  },
  options: {
    collect: '',
    receipt: '',
    reverse: '',
    service: '',
    own_hand: '',
    platform: '',
    reminder: '',
    agency: '',
    non_commercial: '',
    default_shipping: 1,
    client_shipping: {
        price: null,
        tracking: '',
        service_id: '',
        company_name: '',
        service_name: ''
    }
  },
  volumes: [
    {
      width: null,
      format: 'box',
      height: null,
      length: null,
      weight: null,
      diameter: null,
      insurance: ''
    }
  ],
  cotation: {
    id: 1,
    name: 'PAC',
    price: '',
    custom_price: '',
    currency: "R$",
    delivery: {
      min: null,
      max: null
    },
    custom_delivery: {
      min: null,
      max: null
    },
    volumes: [
      {
        height: null,
        width: null,
        length: null,
        weight: null,
        diameter: null,
        format: 'box',
        insurance: null
      }
    ],
    additional_services: {
      receipt: false,
      own_hand: false,
      collect: false
    },
    company: {
      id: 1,
      name: 'Correios',
      picture: ''
    }
  }
}
